// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-list-layout-gallery-item{--image:var(--image);aspect-ratio:var(--aspect-ratio);width:100%}@media (min-width:768px){.h-list-layout-gallery-item{margin:0}}.h-list-layout-gallery-item__node{width:100%;height:100%;background-image:var(--image);background-repeat:no-repeat;background-position:50%;background-size:cover}.h-theme--hoshinoya .h-list-layout-gallery-item__node{border-radius:3px}", ""]);
// Exports
module.exports = exports;
